<template>
  <div>
    <mds-notification-container v-if="showAlert" class="alert-box">
      <mds-notification
        key="sizing-medium"
        size="medium"
        variation="informational"
        :dismiss-delay="dismissVal"
        title="Reporting Concerns"
        role="alert"
        @mds-notification-dismissed="closePopup"
      >
        If an Authorized User experiences difficulties accessing the transaction
        information on this website, or has concerns about the completeness or
        timeliness of information relating to transactions on the 17g5 list,
        please submit the concerns in writing to the Morningstar DBRS Designated
        Compliance Officer at
        <a href="" class="my-link">CreditCompliance@morningstar.com</a>
        <template v-slot:mds-notification-custom-action>
          <mds-button
            type="button"
            variation="secondary"
            text="Send Email"
            @click.prevent="sendEmail()"
          ></mds-button>
        </template>
      </mds-notification>
    </mds-notification-container>
    <div class="container_2">
      <div class="mds-level-6-heading">
        <span>Disclosure Deal List</span>
        <div class="reporting_concern">
          <span>Reporting Concerns</span>
          <span class="fix_icon" @click.prevent="openPopup()">
            <mds-icon
              name="info-circle"
              title="favorite"
              size="small"
            ></mds-icon>
          </span>
        </div>
      </div>
      <mds-loader
        v-if="loading"
        class="loader_container"
        aria-valuetext="loading ..."
      ></mds-loader>
      <div class="table-wrap">
        <table class="mds-data-table__table__mcr-rd">
          <caption class="mds-data-table__caption__mcr-rd"></caption>
          <thead>
            <tr class="mds-data-table__row__mcr-rd">
              <th
                v-for="headerName in headers"
                :key="headerName['index']"
                scope="col"
                class="mds-data-table__header-cell__mcr-rd"
                :style="{ width: headerName['width'] }"
              >
                <div class="mds-data-table__header-cell-inner__mcr-rd">
                  <span class="mds-data-table__header-cell-text__mcr-rd">{{
                    headerName["text"]
                  }}</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="mds-data-table__body__mcr-rd">
            <tr
              v-for="data in rows"
              :key="data['id']"
              class="mds-data-table__row__mcr-rd"
            >
              <td class="mds-data-table__cell__mcr-rd">
                <span>{{ getDate(data.start_date) }}</span>
              </td>
              <td class="mds-data-table__cell__mcr-rd">
                <span>{{ data.issuer_id.name }}</span>
              </td>
              <td class="mds-data-table__cell__mcr-rd">
                <span>{{ data.transaction_name }}</span>
              </td>
              <td class="mds-data-table__cell__mcr-rd">
                <span>{{ data.instrument_id.name }}</span>
              </td>
              <td class="mds-data-table__cell__mcr-rd">
                <span>
                  <a
                    :href="data.url"
                    target="_blank"
                    class="table-url-link"
                    @click="urlclicked(data.url)"
                    >{{ data.url }}</a
                  >
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MdsIcon from "@mds/icon";
import { MdsNotification, MdsNotificationContainer } from "@mds/notification";
import { MdsButton } from "@mds/button";
import { getDealList } from "@/apis/deals.js";
import moment from "moment";
import MdsLoader from "@mds/loader";
import { orderBy } from "lodash";
import { me } from "@/apis/user-authentication";

export default {
  name: "DealList",
  components: {
    MdsIcon,
    MdsButton,
    MdsNotification,
    MdsNotificationContainer,
    MdsLoader,
  },
  data() {
    return {
      headers: [],
      showAlert: false,
      dismissVal: 500000,
      rows: [],
      loading: false,
      userData: {},
    };
  },
  mounted() {
    this.userData = JSON.parse(localStorage.getItem("userData"));
    if (this.$route.path !== "/" && !this.userData) {
      this.userInfo();
    } else {
      this.getDeals();
    }
    this.initData();
  },
  methods: {
    openPopup() {
      this.showAlert = true;
    },
    closePopup() {
      this.showAlert = false;
    },
    sendEmail() {
      window.location = "mailto:CreditCompliance@morningstar.com";
      this.closePopup();
    },
    getDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    initData() {
      this.headers = [
        {
          fieldName: "initiated_date",
          text: "Date Initiated",
          width: "14.5%",
          index: 1,
        },
        {
          fieldName: "issuer_name",
          text: "Issuer",
          width: "36.2%",
          index: 2,
        },
        {
          fieldName: "transaction_name",
          text: "Transaction",
          width: "47.5%",
          index: 3,
        },
        {
          fieldName: "instrument_name",
          text: "Instrument",
          width: "24%",
          index: 4,
        },
        {
          fieldName: "url",
          text: "URL",
          width: "48%",
          index: 5,
        },
      ];
    },
    getDeals() {
      this.loading = true;
      return getDealList()
        .then(resp => {
          this.rows = orderBy(
            resp.data,
            function(x) {
              return moment(x.updated_at).format("YYYY-MM-DD HH:mm:ss");
            },
            "desc",
          );
          this.rows = orderBy(
            resp.data,
            function(x) {
              return moment(x.start_date).format("YYYY-MM-DD HH:mm:ss");
            },
            "desc",
          );
          this.loading = false;
        })
        .catch(err => this.handleError(err));
    },
    handleError(err) {
      this.loading = false;
      this.error = err;
    },
    urlclicked(url) {
      let user = JSON.parse(localStorage.getItem("userData"));
      console.log(user);
      this.$gtag.customMap({
        dimension2: "username",
        dimension3: "email",
        dimension4: "url",
      });
      this.$gtag.event("view_item", {
        event_category: "view_link",
        event_label: "link clicked",
        value: user.id,
        username: user.username,
        email: user.email,
        url: url,
      });
    },
    userInfo() {
      this.loading = true;
      me().then(data => {
        if (data) {
          this.getDeals();
          // call gtag event to track
          this.$gtag.set({ userId: data.data.id });
          this.loading = false;
          localStorage.setItem("userData", JSON.stringify(data.data));
          this.$gtag.customMap({ dimension2: "username", dimension3: "email" });
          this.$gtag.event("login", {
            event_category: "engagement",
            event_label: "user login",
            value: data.data.id,
            username: data.data.username,
            email: data.data.email,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants";
@import "@/styles/reset";

.container_2 {
  width: 1316px;
  margin-left: auto;
  margin-right: auto;
  height: 550px;
}

.mds-level-6-heading {
  @include mds-level-3-heading();
  margin-bottom: $mds-space-3-x;
  margin-top: $mds-space-3-x;
}

.reporting_concern {
  float: right;
  margin-top: 10px;
  @include mds-body-text-s();

  span {
    display: inline-block;
    margin-left: 2px;
  }

  .fix_icon {
    cursor: pointer;
    vertical-align: middle;
  }
}

.alert-box {
  margin-top: $mds-masthead-height + $mds-space-3-x;

  .my-link {
    @include mds-link($underline: false, $visited-styles: false);
    color: #007cc2;
  }
}

.mds-notification-container--top-center__mcr-rd {
  margin-left: auto;
  margin-right: auto;
}

.mds-notification-container__mcr-rd {
  max-width: 600px;
}

.mds-data-table__cell__mcr-rd span a:visited {
  color: #007cc2 !important;
}

.table-url-link {
  @include mds-link($underline: false, $visited-styles: false);
  color: #007cc2;
}

.loader_container {
  margin-left: auto;
  margin-right: auto;
  font-size: 40px !important;
  top: 40%;
}
</style>
